import {
  MyChartOpenSchedulingConfig,
  PMCConfig,
  ProviderMatchProviderV9
} from '@kyruus/types';

import { AvailabilityProps } from './types';
import { BookingStrategies } from '../../types';
import { isProviderCompatibleWithOpenScheduling } from '../../lib/utils';
import {
  EXTENDED_AVAILABILITIES_DISPLAY_LIMIT,
  MAX_AVAILABILITIES_TO_DISPLAY
} from '../../lib/constants';

export function getBookingStrategy(
  config: PMCConfig,
  provider: ProviderMatchProviderV9,
  availabilityProps?: AvailabilityProps
): BookingStrategies {
  let bookingStrategy = BookingStrategies.Button;

  if (availabilityProps?.enabled ?? false) {
    bookingStrategy = BookingStrategies.Availability;
  }

  if (!(convertXPFieldToBoolean(provider.disable_osw_iframe) ?? true)) {
    if (config.third_party?.mychart_open_scheduling) {
      if (config.third_party.mychart_open_scheduling.enabled) {
        if (
          isProviderCompatibleWithOpenScheduling(
            config.third_party.mychart_open_scheduling,
            provider
          )
        ) {
          return BookingStrategies.OpenSchedulingWidget;
        }
      }
    }
  }

  return bookingStrategy;
}

export function convertXPFieldToBoolean(field?: string): boolean {
  switch (field?.toLowerCase()) {
    case 'true':
    case 'yes':
      return true;
    case 'false':
    case 'no':
      return false;
    default:
      return false;
  }
}

export interface ShowAvailableWithinDaysOptions {
  config: PMCConfig;
  availabilityDensityBest?: string;
}

export interface ValidatedShowAvailabilityWithinDays {
  config: PMCConfig;
  availabilityDensityBest: string;
}

export function showAvailableWithinDays(
  props: ShowAvailableWithinDaysOptions
): props is ValidatedShowAvailabilityWithinDays {
  if (props.config?.hide_availability_density ?? true) {
    return false;
  }

  if (props.availabilityDensityBest) {
    return true;
  } else {
    return false;
  }
}

export function getOpenSchedulingConfig(config: PMCConfig) {
  return config.third_party
    ?.mychart_open_scheduling as Required<MyChartOpenSchedulingConfig>;
}

export function getShouldRenderDirectBookInDrawer(config: PMCConfig) {
  return (
    config?.direct_book?.render_type ||
    config?.feature_flags?.dbw_render_in_drawer === true
  );
}

export function getShowRegulatedSpacesBanner(config: PMCConfig) {
  return config?.direct_book?.show_regulated_spaces_banner || false;
}

export function getMaxAvailabilitiesToDisplay(config: PMCConfig) {
  return config?.feature_flags
    ?.extended_availability_tiles_limit_for_profile_page
    ? EXTENDED_AVAILABILITIES_DISPLAY_LIMIT
    : MAX_AVAILABILITIES_TO_DISPLAY;
}
